import './style.css'

interface DateTimeInputProps {
  onChange: Function
  value: string
}

const DateTimeInput: React.FC<DateTimeInputProps> =
  ({ onChange, value }) => (
    <input
      className="datetime-input"
      type='datetime-local'
      step='3600'
      onChange={(e) => { onChange(e)}}
      value={value}
    />
  )

export default DateTimeInput;